var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"has-text-weight-bold",class:_vm.presenter.textClass},[_vm._v(_vm._s(_vm.presenter.label))])}
var staticRenderFns = []

export { render, staticRenderFns }